// Returns the dashboard path for a given user role.
export const dashboardPathFor = (role) => {
  if (role === 'admin') return '/admin';
  if (role === 'organizer') return '/organizer';
  return '/player-dashboard';
};

export const NAV_LINKS = [
  { to: '/tournaments', label: 'Tournaments', testId: 'nav-tournaments' },
  { to: '/how-to-list', label: 'For Organizers', testId: 'nav-organizers' },
  { to: '/about', label: 'About', testId: 'nav-about' },
  { to: '/faq', label: 'FAQ', testId: 'nav-faq' }
];
